import React, { useState } from 'react';
import cx from 'classnames';
import { SpriteProps, SpriteContext } from './sprite-types';

import { goodSprite } from './contants';
import useDocumentProperty from '../../../custom-hooks/useDocumentProperty';

const getInt = (str: string) => parseInt(str, 10);

type Props = {
    context: SpriteContext;
    styles: any;
} & SpriteProps;
export default function Sprite(props: Props) {
    const {
        context,
        styles,
        spriteId,
        scale = 1,
        noHover = false,
        sheetIndexUnhovered = 0,
        sheetIndexHovered,
        color,
    } = props;

    if (!goodSprite(spriteId))
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {spriteId}
                <i
                    style={{ transform: `scale(${scale * 2})`, color: 'red' }}
                    className='material-icons-outlined'
                >
                    block
                </i>
            </div>
        );

    /*
     *
     * SheetIndex refers to color-selector in the sprite-sheet
     * not-hovered: 0
     * hovered: 1
     *
     * 0, 1 is the vertical position multiplier in the sheet
     *
     * NOTE: Some sheets can have multiple colors.
     *       This is why I do not hardcode 0:not-hovered and 1:hovered
     *
     * */

    const [selectedSprite, setSelectedSprite] = useState(sheetIndexUnhovered);
    const setHover = (on: boolean) => {
        if (noHover) return;
        setSelectedSprite(
            on ? (sheetIndexHovered ?? sheetIndexUnhovered + 1) : sheetIndexUnhovered
        );
    };
    const spriteWidth = getInt(useDocumentProperty(`--${context}-sprite-width`).get());
    const spriteHeight = getInt(useDocumentProperty(`--${context}-sprite-height`).get());

    const divLevel1 = {
        width: `${spriteWidth * scale}px`,
        height: `${spriteHeight * scale}px`,
    };
    const divLevel2 = {
        transformOrigin: '0 0',
        transform: `scale(${scale})`,
    };
    const spriteStyle = {
        backgroundPositionY: `${selectedSprite * -1 * spriteHeight}px`,
        color,
    };

    return (
        <div style={divLevel1}>
            <div style={divLevel2}>
                <div
                    onMouseOver={() => setHover(true)}
                    onMouseOut={() => setHover(false)}
                    aria-label={`${spriteId}`}
                    className={cx(styles.sprite, styles[`${spriteId}`])}
                    style={spriteStyle}
                />
            </div>
        </div>
    );
}
